import React, { Component } from 'react'

import throttle from 'lodash.throttle'
import { Try } from 'monapt'

export type State = {
  pageWidth: number
  scrollBottom: number
  scrollTop: number
}

export const calculateScrollBottom = () =>
  Try(() => document.body.scrollHeight - (window.scrollY + window.innerHeight)).getOrElse(() => 0)

export default WrappedComponent =>
  class PageTop extends Component {
    public readonly state: State = {
      pageWidth: window.innerWidth,
      scrollBottom: calculateScrollBottom(),
      scrollTop: window.pageYOffset,
    }

    public handleScroll = throttle(() => {
      if (
        this.state.scrollTop !== window.pageYOffset ||
        this.state.pageWidth !== window.innerWidth
      ) {
        this.setState({
          pageWidth: document.body.clientWidth || window.innerWidth,
          scrollBottom: calculateScrollBottom(),
          scrollTop: window.pageYOffset,
        })
      }
    }, 10)

    public render() {
      return <WrappedComponent {...this.state} {...this.props} />
    }

    public componentDidMount() {
      window.addEventListener('resize', this.handleScroll)
      window.addEventListener('scroll', this.handleScroll)

      this.setState({
        pageWidth: window.innerWidth,
        scrollBottom: calculateScrollBottom(),
        scrollTop: window.pageYOffset,
      })
    }

    public componentWillUnmount() {
      window.removeEventListener('resize', this.handleScroll)
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
